window.addEventListener('load', e=>{
  const showLabelToltip = (input) =>{
    input.parentNode.querySelector('.toltip').classList.remove('focus');
    input.parentNode.querySelector('label').classList.remove('focus')
}
    console.log('test');
    let btnOpenCalculators = document.querySelector('#open-calculator');
    let btnCloseCalculators = document.querySelector('.calculators .btn-close');
    btnOpenCalculators.addEventListener('click', e => {
        e.stopPropagation(); // Evita la propagación del evento al documento
        let calculators = document.querySelector('.calculators');
        if (calculators.classList.contains('open')) {
            calculators.classList.remove('open');
        } else {
            calculators.classList.add('open');
        }
    });
    btnCloseCalculators.addEventListener('click', e=>{
      let calculators = document.querySelector('.calculators');
      calculators.classList.remove('open');
    });
    
    let calculatorsContainer = document.querySelector('.calculators');
    /*
    document.addEventListener("click", function(event) {
        let calculatorsContainer = document.querySelector('.calculators');
    
        var isClickInside = calculatorsContainer.contains(event.target);
    
        if (!isClickInside && calculatorsContainer.classList.contains('open')) {
            calculatorsContainer.classList.remove("open");
        }
    });
    */
    
    let calculators = document.querySelectorAll('.calculators .calculator');
    let calculatorsFloat = document.querySelectorAll('.calculator-float');
    
    calculators.forEach(calculator => {
        let form = calculator.querySelector('form');
        let btnFloat = calculator.querySelector('.btn-float');
        let btnDropdown = calculator.querySelector('.btn-dropdown');
        let header = calculator.querySelector('.calculator-head');
        let heightBodyContainer = calculator.querySelector('.body-container').offsetHeight;
        let bodyContainer = calculator.querySelector('.calculator-body');
        let calculatorDataId = calculator.getAttribute('data-id');
        let btnReset = calculator.querySelector('.btn-reset');
        console.log(heightBodyContainer);
        header.addEventListener('click', e => {
          heightBodyContainer = form.parentElement.offsetHeight;
          console.log(heightBodyContainer);
            e.stopPropagation(); // Evitar la propagación del evento al contenedor .calculators
            if (btnDropdown.classList.contains('open')) {
                calculator.classList.remove('open');
                btnDropdown.classList.remove('open');
                bodyContainer.style.height = '0px';
            } else {
                btnDropdown.classList.add('open');
                calculator.classList.add('open');
                bodyContainer.style.height = `${heightBodyContainer}px`;
            }
        })
        btnFloat.addEventListener('click', e=>{
            e.stopPropagation(); // Evitar la propagación del evento al contenedor .calculators
            /*if (btnFloat.classList.contains('open')) {
                btnFloat.classList.remove('open');
                calculator.classList.remove('float');
                calculatorsFloat.forEach(calculatorF=>{
                    let cfid = calculatorF.getAttribute('data-id');
    
                    if(cfid == calculatorDataId){
                        calculatorF.classList.remove('open');
                    }
                })
            } else {
            }*/
            btnFloat.classList.add('open');
            calculator.classList.add('float');
            //detenerArrastre();
            calculatorsFloat.forEach(calculatorF=>{
                let cfid = calculatorF.getAttribute('data-id');
                let bodyContainerFloat = calculatorF.querySelector('.calculator-body');
                let heightBodyContainer = calculatorF.querySelector('.body-container').offsetHeight;
                let btnDropdown = calculatorF.querySelector('.btn-dropdown');
                if(cfid == calculatorDataId){
                    calculatorF.classList.add('open');
                    btnDropdown.classList.add('open');
                    bodyContainerFloat.style.height = `${heightBodyContainer}px`;
                    dragElement(calculatorF);
                }
            })
        })
        btnReset.addEventListener('click', e=>{
          calculator.querySelectorAll('input').forEach(input=>{
            showLabelToltip(input)
          });
        })
    })
    calculatorsFloat.forEach(calculatorF=>{
        let cfid = calculatorF.getAttribute('data-id');
        let btnClose = calculatorF.querySelector('.btn-close');
        let btnCursorMove = calculatorF.querySelector('.btn-float');
        let heightBodyContainer = calculatorF.querySelector('.body-container').offsetHeight;
        let btnDropdown = calculatorF.querySelector('.btn-dropdown');
        let bodyContainer = calculatorF.querySelector('.calculator-body');
        let btnReset = calculatorF.querySelector('.btn-reset');
        btnDropdown.addEventListener('click', e => {
            e.stopPropagation(); // Evitar la propagación del evento al contenedor .calculators
            if (btnDropdown.classList.contains('open')) {
                btnDropdown.classList.remove('open');
                bodyContainer.style.height = '0px';
            } else {
                btnDropdown.classList.add('open');
                bodyContainer.style.height = `${heightBodyContainer}px`;
            }
        })
        btnClose.addEventListener('click', e=>{
            calculatorF.classList.remove('open');
            calculators.forEach(calculator=>{
                let calculatorId = calculator.getAttribute('data-id');
                if(calculatorId == cfid){
                    calculator.classList.remove('float');
                }
            });
        })
        btnCursorMove.addEventListener('click', e=>{
          calculatorF.classList.remove('open');
          calculators.forEach(calculator=>{
              let calculatorId = calculator.getAttribute('data-id');
              if(calculatorId == cfid){
                  calculator.classList.remove('float');
              }
          });
        })
        btnReset.addEventListener('click', e=>{
          calculator.querySelectorAll('input').forEach(input=>{
            showLabelToltip(input)
          });
        })
    })
    
    //hacer que el elemento flote
    
    function dragElement(elmnt) { 
        let elementHeader = elmnt.querySelector('.calculator-head');
        var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
        if (elementHeader) {
          /* if present, the header is where you move the DIV from:*/
          elementHeader.onmousedown = dragMouseDown;
        } else {
          /* otherwise, move the DIV from anywhere inside the DIV:*/
          elmnt.onmousedown = dragMouseDown;
        }
      
        function dragMouseDown(e) {
            e.stopPropagation(); 
          e = e || window.event;
          e.preventDefault();
          // get the mouse cursor position at startup:
          pos3 = e.clientX;
          pos4 = e.clientY;
          document.onmouseup = closeDragElement;
          // call a function whenever the cursor moves:
          document.onmousemove = elementDrag;
        }
      
        function elementDrag(e) {
            e.stopPropagation(); 
          e = e || window.event;
          e.preventDefault();
          // calculate the new cursor position:
          pos1 = pos3 - e.clientX;
          pos2 = pos4 - e.clientY;
          pos3 = e.clientX;
          pos4 = e.clientY;
          // set the element's new position:
          elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
          elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
        }
      
        function closeDragElement() {
          /* stop moving when mouse button is released:*/
          document.onmouseup = null;
          document.onmousemove = null;
        }
  }
    
    //createSortable("#calculators");
    
    function createSortable(selector) {
      console.log(selector);
      var sortable = document.querySelector(selector);
        Draggable.create(sortable.children, {
            type: "y",
            bounds: sortable,
            edgeResistance: 1,
            onPress: sortablePress,
            onDragStart: sortableDragStart,
            onDrag: sortableDrag,
            liveSnap: sortableSnap,
            onDragEnd: sortableDragEnd,
            enabled: function() {
                return !this.target.classList.contains('float');
            }
        });
    
    }
    function detenerArrastre() {
        var sortable = document.querySelector("#calculators");
        var draggableElements = Draggable.create(sortable.children, {
            type: "y",
            bounds: sortable,
            edgeResistance: 1,
            onPress: sortablePress, 
            onDragStart: sortableDragStart,
            onDrag: sortableDrag,
            liveSnap: sortableSnap,
            onDragEnd: sortableDragEnd,
            enabled: function() {
                return !this.target.classList.contains('float');
            }
        });
        habilitarArrastre = false;
        draggableElements.forEach(function(draggableElement) {
            draggableElement.kill();
        });
    }
    
    function sortablePress(event) {
      var t = this.target,
          i = 0,
          child = t;  
      
      while(child = child.previousSibling) {
        if (child.nodeType === 1) i++;
      }
      
      t.currentIndex = i;
      t.currentHeight = t.offsetHeight;
      t.kids = Array.prototype.slice.call(t.parentNode.children, 0);
    }
    
    function sortableDragStart() {
      //TweenLite.set(this.target, { color: "#88CE02" });
      calculators.forEach(calculator => {
        let btnFloat = calculator.querySelector('.btn-float');
        let btnDropdown = calculator.querySelector('.btn-dropdown');
        let heightBodyContainer = calculator.querySelector('.body-container').offsetHeight;
        let bodyContainer = calculator.querySelector('.calculator-body');
        btnDropdown.classList.remove('open');
        bodyContainer.style.height = '0px';
    })
    }
                     
    function sortableDrag() {
        
      var t = this.target,      
          elements = t.kids.slice(0), // clone      
          indexChange = Math.round(this.y / t.currentHeight),
          bound1 = t.currentIndex,
          bound2 = bound1 + indexChange;
          
      if (bound1 < bound2) { // moved down
        TweenLite.to(elements.splice(bound1+1, bound2-bound1), 0.15, { yPercent: -100 });
        TweenLite.to(elements, 0.15, { yPercent: 0 });
      } else if (bound1 === bound2) {
        elements.splice(bound1, 1);
        TweenLite.to(elements, 0.15, { yPercent: 0 });
      } else { // moved up
        TweenLite.to(elements.splice(bound2, bound1-bound2), 0.15, { yPercent: 100 });
        TweenLite.to(elements, 0.15, { yPercent: 0 });
      }
    }
    
    function sortableSnap(y) {
        
      var h = this.target.currentHeight;
      return Math.round(y / h) * h;
    }
                     
    function sortableDragEnd() {
      
      var t = this.target,
          max = t.kids.length - 1,
          yPos = this.y || endY,
          newIndex = Math.round(this.y / t.currentHeight);  
      
      newIndex += (newIndex < 0 ? -1 : 0) + t.currentIndex;
      if (newIndex === max) {
        t.parentNode.appendChild(t);
      } else {
        t.parentNode.insertBefore(t, t.kids[newIndex+1]);
      }
      TweenLite.set(t.kids, { yPercent: 0, overwrite: "all" });
      TweenLite.set(t, { y: 0, color: "" });
    }
    document.querySelectorAll('form .form-group').forEach(group=>{
      let toltip = group.querySelector('.toltip');
      let lavel = group.querySelector('label');
      let input = group.querySelector('input');
      input.addEventListener('focus', e=>{
        lavel.classList.add('focus');
        console.log('focus');
        toltip.classList.add('focus');
      })
      input.addEventListener('blur', e=>{
        if(input.value == ''){
          lavel.classList.remove('focus');
          console.log('quitando el focus');
          toltip.classList.remove('focus');
        }
      })
      input.addEventListener('input', e=>{
        input.setAttribute('data-number', input.value);
        console.log(input.value);
      })
      input.addEventListener('change', e=>{
        console.log('cambiando ' + input.value);
        
        if(!input.value == ''){
          lavel.classList.add('focus');
          console.log('quitando el focus');
          toltip.classList.add('focus');
        }
      })
    })
    let inputs = document.querySelectorAll('form .form-group input');

    // permitir que solo se escriban numeros en los inputs
    inputs.forEach(input => {
        input.addEventListener('input', function() {
          if(input.getAttribute('name') == 'tc-c' || input.getAttribute('name') == 'c' || input.getAttribute('name') == 'tc-c-f' || input.getAttribute('name') == 'tc-f' || input.getAttribute('name') == 'tc-f-f' || input.getAttribute('name') == 'f'){
            console.log('celcius');
            this.value = this.value.replace(/(?!^-)[^0-9.]/g, "").slice(0, 13);
          }else{
              this.value = this.value.replace(/[^0-9.]/g, "").slice(0, 13);
              console.log('otro campo');
            }
        });
    });
})